import React, {useEffect, useState} from 'react'
import {toast, ToastItem} from 'react-toastify'
import {ToastErrorCollapserWrapper} from './ToastErrorCollapser.styles'

export const ToastErrorCollapser = () => {
  const [showCollapser, setShowCollapser] = useState(false)

  useEffect(() => {
    const toastErrors = new Set()

    const unsubscribe = toast.onChange(currentToast => {
      if (currentToast.status === 'added') {
        toastErrors.add(currentToast.id)
      } else if (currentToast.status === 'removed') {
        toastErrors.delete(currentToast.id)
      }
      setShowCollapser(toastErrors.size > 1)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  const collapseAllToast = () => {
    toast.clearWaitingQueue()
    toast.dismiss()
    setShowCollapser(false)
  }

  return (
    <ToastErrorCollapserWrapper
      id='toastCollapser'
      onClick={collapseAllToast}
      style={{
        display: showCollapser ? 'block' : 'none'
      }}
    >
      Скрыть всё
    </ToastErrorCollapserWrapper>
  )
}
